import shoppingIndex from "@/views/shopping/shoppingIndex.vue";
import dishIndex from "@/views/shopping/dish/index.vue";
import eatIndex from "@/views/shopping/eat/index.vue";
import refundIndex from "@/views/shopping/refund/index.vue";
import changeIndex from "@/views/shopping/change/index.vue";
import powerIndex from "@/views/shopping/power/index.vue";

export default {
  path: "/shopping",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "shoppingIndex",
      name: "shoppingIndex",
      component: shoppingIndex,
    },
    // 手机买菜页面
    {
      path: "dish/index",
      name: "dishIndex",
      component: dishIndex,
    },
    // 手机点餐页面
    {
      path: "eat/index",
      name: "eatIndex",
      component: eatIndex,
    },
    // 网购退货页面
    {
      path: "refund/index",
      name: "refundIndex",
      component: refundIndex,
    },
    // 网购换货页面
    {
      path: "change/index",
      name: "changeIndex",
      component: changeIndex,
    },
    // 网购维权页面
    {
      path: "power/index",
      name: "powerIndex",
      component: powerIndex,
    },
  ],
};
